<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h480_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="11">
                  <div class="search-box">
                    <el-input
                      v-model="employeeFilterText"
                      placeholder="查询用户"
                    />
                  </div>
                  <div class="left left-list-box">
                    <ul>
                      <li
                        v-for="(item,index) in employeeData"
                        :key="item.index"
                        :class="{'active':index==employeeCurrent}"
                        @dblclick="addToFlowList(item, index)"
                        @click="employeeCheckedFun(item, index)"
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                </el-col>

                <el-col :span="2">
                  <div class="transfer-button">
                    <el-button
                      type="success"
                      plain
                      @click="addFlowEmployeeFun"
                    >
                      添加
                    </el-button>
                    <el-button
                      type="warning"
                      plain
                      @click="deleteFlowEmployeeFun"
                    >
                      删除
                    </el-button>
                  </div>
                </el-col>

                <el-col :span="11">
                  <div class="right">
                    <ul class="right-list">
                      <!-- <li class="order">顺序</li> -->
                      <li class="employee">
                        维护人
                      </li>
                    </ul>
                    <div class="right-list-box">
                      <ul>
                        <draggable
                          :list="flowEmployeeData"
                          group="article"
                          class="dragArea"
                        >
                          <div
                            v-for="(element, index) in flowEmployeeData"
                            :key="index"
                            class="list-complete-item"
                            :class="{'active':index==flowEmployeeCurrent}"
                            @dblclick="deleteToFlowList(element, index)"
                            @click="flowCheckedFun(element, index)"
                          >
                            <!-- <li class="order">{{index + 1}}</li> -->
                            <li class="employee">
                              {{ element.name }}
                            </li>
                            <!-- <li class="department">{{element.departmentName}}</li> -->
                          </div>
                        </draggable>
                      </ul>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { loadUserSelectDataByUserTypeApi } from '@/api/user'
import { initStoreApi, saveOrUpdateStoreApi } from '@/api/store'
export default {
  components: { draggable },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {
        id: null,
        manageUserId: '',
        manageUserName: ''
      },
      dialogAddEditViewFormRules: {},
      employeeFilterText: '', // 职员集合过滤文字
      employeeData: [], // 职员数据源
      constEmployeeData: [],
      employeeChecked: null,
      employeeCurrent: -1,
      flowEmployeeData: [],
      flowEmployeeChecked: null,
      flowEmployeeCurrent: -1
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.dialogAddEditViewForm = {
          id: this.dataId,
          manageUserId: '',
          manageUserName: ''
        }
        this.employeeFilterText = ''
        this.constEmployeeData = []
        this.employeeChecked = null
        this.employeeCurrent = -1
        this.flowEmployeeData = []
        this.flowEmployeeChecked = null
        this.flowEmployeeCurrent = -1
        this.loading = false
        this.getEmployeeData()
        this.initPageData()
      }
    },
    employeeFilterText (val) {
      this.employeeData = this.constEmployeeData.filter(list => {
        return list.name.indexOf(val) !== -1
      })
    }
  },
  methods: {
    // 加载数据
    initPageData () {
      initStoreApi({ id: this.dataId }).then(res => {
        const { data } = res
        let manageUserNameArray = data.manageUserName.split(',')
        data.manageUserId.split(',').forEach((item, index) => {
          this.flowEmployeeData.push({ id: item, name: manageUserNameArray[index]})
        })
        this.loading = false
      })
    },
    // 获取职员清单
    getEmployeeData () {
      loadUserSelectDataByUserTypeApi().then(response => {
        const { data } = response
        this.employeeData = data
        this.constEmployeeData = data
        this.employeeChecked = null
        this.employeeCurrent = -1
      })
    },
    employeeCheckedFun (item, index) {
      this.employeeCurrent = index
      this.employeeChecked = item
    },
    flowCheckedFun (item, index) {
      this.flowEmployeeCurrent = index
      this.flowEmployeeChecked = item
    },
    addFlowEmployeeFun () {
      if (!this.employeeChecked) {
        this.$message.error('请选择要添加的用户')
        return
      }
      let hasItem = false
      this.flowEmployeeData.forEach(item => {
        if (item.id === this.employeeChecked.id) {
          hasItem = true
        }
      })
      if (!hasItem) {
        this.flowEmployeeData.push(this.employeeChecked)
      }
    },
    deleteFlowEmployeeFun () {
      if (!this.flowEmployeeChecked) {
        this.$message.error('请选择要删除的用户')
        return
      }
      let index = this.flowEmployeeData.indexOf(this.flowEmployeeChecked)
      if (index >= 0) {
        this.flowEmployeeCurrent = -1
        this.flowEmployeeData.splice(index, 1)
      }
    },
    addToFlowList (item, index) {
      this.employeeCheckedFun(item, index)
      this.addFlowEmployeeFun()
    },
    deleteToFlowList (item, index) {
      this.flowCheckedFun(item, index)
      this.deleteFlowEmployeeFun()
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          if (this.flowEmployeeData.length < 1) {
            this.$message.error('请选择维护人')
            return false
          } else {
            let manageUserId = ''
            let manageUserName = ''
            this.flowEmployeeData.forEach(item => {
              manageUserId += ',' + item.id
              manageUserName += ',' + item.name
            })
            manageUserId = manageUserId.substring(1)
            manageUserName = manageUserName.substring(1)
            this.dialogAddEditViewForm.manageUserId = manageUserId
            this.dialogAddEditViewForm.manageUserName = manageUserName
          }
          this.$confirm(
            '是否确定保存','系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText:'取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.editSave()
            })
            .catch(() => { })
        }
      })
    },
    // 保存修改
    editSave () {
      saveOrUpdateStoreApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
.search-box{
  width:100%;
  margin-bottom:10px;
  margin-top: 10px;
}
.left {
  width:100%;
  height: 250px;
  border: 1px solid #e6ebf5;
  float: left;
  background: #fff;
  box-sizing: border-box;
  margin-bottom:10px;
}
.right {
  width: 100%;
  height: 250px;
  border: 1px solid #e6ebf5;
  float: left;
  background: #fff;
  box-sizing: border-box;
  margin-top: 48px;
  margin-bottom:10px;
}
.left {
  padding: 5px 0;
}
.left li{
  padding:0 5px;
}
.left-list-box {
  overflow-x: hidden;
  overflow: auto;
}
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px;
  line-height: 20px;
}
.transfer-button {
  width: 70px;
  float: left;
  padding-top:120px;
  text-align: center;
}
.transfer-button .el-button {
  margin: 10px 0;
  flex:1
}
.right {
  width: 100%;
}
.right-list,
.list-complete-item {
   width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  box-sizing: border-box;
  display: flex;
  overflow-x: hidden;

}
.right-list li ,.list-complete-item li{
  padding: 0 5px;
  margin: 0;
  line-height: 24px;
  border-bottom: 1px solid #e6ebf5;
  flex:1;
}
li.order {
 flex:0 1 60px;
 width:60px;
  border-right: 1px solid #e6ebf5;
}
 li.employee {
  border-right: 1px solid #e6ebf5;
  text-align: center;
}
.right-list>li{
  background: #efefef;
}
.li:hover {
  background: #b2e1ff;
}
.active {
  background: #7fceff;
}
.right-list-box {
  height: 224px;
  overflow-x: hidden;
  overflow: auto;
}
</style>
